import type { ShiftAssignment } from '@/types/shift.types'

const ATTENDANCE_ASSIGNMENT_STATUSES = new Set(['scheduled', 'confirmed'])

export function isAdminRole(roleSlug?: string | null): boolean {
  return (roleSlug ?? '').toLowerCase() === 'admin'
}

export function canAccessAttendanceSelfService(params: {
  roleSlug?: string | null
  canRead: boolean
}): boolean {
  return params.canRead && !isAdminRole(params.roleSlug)
}

export function hasAttendanceEligibleAssignment(
  assignment: ShiftAssignment | null | undefined,
): boolean {
  return Boolean(
    assignment && ATTENDANCE_ASSIGNMENT_STATUSES.has(assignment.status),
  )
}
